"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stacks 2.0 Blockchain API
 * This is the documentation for the Stacks 2.0 Blockchain API.  It is comprised of two parts; the Stacks Blockchain API and the Stacks Core API.  <a href=\"collection.json\" download=\"collection.json\">Download Postman collection</a>
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressTokenOfferingLockedToJSON = exports.AddressTokenOfferingLockedFromJSONTyped = exports.AddressTokenOfferingLockedFromJSON = void 0;
const _1 = require("./");
function AddressTokenOfferingLockedFromJSON(json) {
    return AddressTokenOfferingLockedFromJSONTyped(json, false);
}
exports.AddressTokenOfferingLockedFromJSON = AddressTokenOfferingLockedFromJSON;
function AddressTokenOfferingLockedFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'total_locked': json['total_locked'],
        'total_unlocked': json['total_unlocked'],
        'unlock_schedule': (json['unlock_schedule'].map(_1.AddressUnlockScheduleFromJSON)),
    };
}
exports.AddressTokenOfferingLockedFromJSONTyped = AddressTokenOfferingLockedFromJSONTyped;
function AddressTokenOfferingLockedToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'total_locked': value.total_locked,
        'total_unlocked': value.total_unlocked,
        'unlock_schedule': (value.unlock_schedule.map(_1.AddressUnlockScheduleToJSON)),
    };
}
exports.AddressTokenOfferingLockedToJSON = AddressTokenOfferingLockedToJSON;
//# sourceMappingURL=AddressTokenOfferingLocked.js.map